import './application-process.scss';
import Swiper from 'swiper';
import { Navigation, A11y, Pagination } from 'swiper/modules';
import { ResizeHandler } from './../../utilities/js/resize-handler';

class ApplicationProcess {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-applicationprocess',
            sliderAttr: 'slider',
            slideAttr: 'slide',
            slideContentAttr: 'slide-content',
            indicatorAttr: 'indicator',
            stepperAttr: 'stepper'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.applicationProcessSlider = null;
        this.activeIndex = 0;

        // Elements
        this.$applicationProcess = element;
        this.$applicationProcessContainer = this.$applicationProcess.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$$applicationProcessSlides = this.$applicationProcess.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.$applicationProcessStepper = this.$applicationProcess.querySelector(`[${this.settings.initAttr}="${this.settings.stepperAttr}"]`);
        this.$$applicationProcessIndicator = this.$applicationProcess.querySelectorAll(`[${this.settings.initAttr}="${this.settings.indicatorAttr}"]`);

        // Options
        this.slideWidth = this.$$applicationProcessSlides.length > 0 ? this.$$applicationProcessSlides[0].querySelector(`[${this.settings.initAttr}="${this.settings.slideContentAttr}"]`)?.clientWidth : 0;

        this.resizeHandler = new ResizeHandler();
        this.resizeHandler.init();
    }

    initialize () {
        this.initSlider();
        this.setEvents();
    }

    initSlider () {
        this.applicationProcessSlider = new Swiper(this.$applicationProcessContainer, {
            modules: [Navigation, Pagination, A11y],
            speed: 500,
            effect: 'fade',
            slidesPerView: 1,
            centeredSlides: true,
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                paginationBulletMessage: 'Springe zu Slide {{index}}',
                firstSlideMessage: 'Dies ist der Erste Slide',
                lastSlideMessage: 'Dies ist der Letzte Slide',
                slideLabelMessage: 'Slide {{index}} von {{slidesLength}}'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
            }
        });

        this.activeIndex = this.applicationProcessSlider.activeIndex;
        this.toggleIndicatorState();

        if (window.innerWidth < 768) {
            this.setStepperOffset();
        }

        this.applicationProcessSlider.on('slideChange', () => {
            this.activeIndex = this.applicationProcessSlider.activeIndex;
            this.toggleIndicatorState();

            if (window.innerWidth < 768) {
                this.setStepperOffset();
            }
        });
    }

    toggleIndicatorState () {
        for (let index = 0; index < this.$$applicationProcessIndicator.length; index++) {
            if (this.activeIndex !== index) {
                this.$$applicationProcessIndicator[index].classList.remove('application-process__step-indicator--active');
            } else {
                this.$$applicationProcessIndicator[index].classList.add('application-process__step-indicator--active');
            }
        }
    }

    setStepperOffset () {
        let offset = 0;
        let alignment = 'center';

        if (this.$applicationProcessStepper.clientWidth > this.slideWidth) {
            offset = (this.activeIndex / (this.$$applicationProcessIndicator.length - 1)) * (this.$applicationProcessStepper.clientWidth - this.slideWidth) * -1;
            alignment = 'flex-start';
        }

        this.$applicationProcessStepper.style.setProperty('--offset', `${offset}px`);
        this.$applicationProcessStepper.style.setProperty('--alignment', alignment);
    }

    setEvents () {
        if (this.$$applicationProcessIndicator.length > 0) {
            this.$$applicationProcessIndicator.forEach(($indicator, index) => {
                $indicator.addEventListener('click', () => {
                    this.activeIndex = index;
                    this.toggleIndicatorState();
                    this.applicationProcessSlider.slideTo(index);

                    if (window.innerWidth < 768) {
                        this.setStepperOffset();
                    }
                });
            });
        }

        this.resizeHandler.customFunctions.push(() => {
            if (window.innerWidth < 768) {
                this.slideWidth = this.$$applicationProcessSlides.length > 0 ? this.$$applicationProcessSlides[0].querySelector(`[${this.settings.initAttr}="${this.settings.slideContentAttr}"]`)?.clientWidth : 0;
                this.setStepperOffset();
            }
        });
    }
}

export { ApplicationProcess };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$applicationProcess = $context.querySelectorAll('[data-applicationprocess="root"]');
        for (let i = 0; i < $$applicationProcess.length; i++) {
            const $applicationProcess = $$applicationProcess[i];

            const $applicationProcessAPI = new ApplicationProcess($applicationProcess);
            $applicationProcessAPI.initialize();
        }
    }
});
